import React from 'react';
import { useParams } from 'react-router-dom';
import SubPage from '#/common/components/SubPage';
import useTenantQuery from '../hooks/useTenantQuery';
import TenantForm from '../components/TenantForm/TenantForm';
import getFormTitle from '#/common/utils/getFormTitle';

export interface TenantParams {
  readonly id?: string;
}

const TenantPage: React.FC = () => {
  const { id } = useParams() as TenantParams;
  const tenantQuery = useTenantQuery(id);
  const tenant = tenantQuery.data?.getTenant?.data;

  const name = tenant?.name;
  const title = getFormTitle(id, name, 'Organization');
  return (
    <SubPage title={title} isLoading={tenantQuery.loading} showGoBackButton type="form">
      <TenantForm tenant={tenant || {}} title={title} />
    </SubPage>
  );
};

export default React.memo(TenantPage);
